(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c-product-badges"] && !Shopify.designMode) return;
  try {
    // No JavaScript needed for static badges
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-product-form"] && !Shopify.designMode) return;
  try {
    // Form JavaScript will be handled by the main section
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-product-gallery"] && !Shopify.designMode) return;
  try {
    // Product Gallery JavaScript will be handled by the main section
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-product-icons"] && !Shopify.designMode) return;
  try {
    // No JavaScript needed for static icons
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-product-shipping"] && !Shopify.designMode) return;
  try {
    // Date calculation will be handled by the main section JavaScript
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-sticky-atc"] && !Shopify.designMode) return;
  try {
    // Sticky ATC functionality will be handled by the main section JavaScript
  } catch(e) { console.error(e); }
})();

})();
